import script from "./SoftLimits.vue?vue&type=script&setup=true&lang=ts"
export * from "./SoftLimits.vue?vue&type=script&setup=true&lang=ts"

import "./SoftLimits.vue?vue&type=style&index=0&id=394e8ca4&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-394e8ca4"]])

export default __exports__